import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from 'js-cookie';

export default function PublicRoute(props) {

    return (
        <>
            {
                    (localStorage.getItem('mhet_cnd_token')) ? (
                        <Navigate to={`/${localStorage.getItem('mhet_cnd_project') ? localStorage.getItem('mhet_cnd_project') : "mhcet"}/home`} />
                    )
                        :
                        (
                            props.children
                        )
            }
        </>
    )
};